// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICategorySpendLimitDto
 */
export interface ICategorySpendLimitDto {
    /**
     * 
     * @type {number}
     * @memberof ICategorySpendLimitDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ICategorySpendLimitDto
     */
    policy_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICategorySpendLimitDto
     */
    category_type?: ICategorySpendLimitDtoCategoryTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ICategorySpendLimitDto
     */
    category_spend_limit?: number;
    /**
     * 
     * @type {number}
     * @memberof ICategorySpendLimitDto
     */
    total_spent?: number;
    /**
     * 
     * @type {Date}
     * @memberof ICategorySpendLimitDto
     */
    valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ICategorySpendLimitDto
     */
    valid_to?: Date;
}

/**
* @export
* @enum {string}
*/
export enum ICategorySpendLimitDtoCategoryTypeEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}


/**
 * Check if a given object implements the ICategorySpendLimitDto interface.
 */
export function instanceOfICategorySpendLimitDto(value: object): value is ICategorySpendLimitDto {
    return true;
}

export function ICategorySpendLimitDtoFromJSON(json: any): ICategorySpendLimitDto {
    return ICategorySpendLimitDtoFromJSONTyped(json, false);
}

export function ICategorySpendLimitDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICategorySpendLimitDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'policy_id': json['policy_id'] == null ? undefined : json['policy_id'],
        'category_type': json['category_type'] == null ? undefined : json['category_type'],
        'category_spend_limit': json['category_spend_limit'] == null ? undefined : json['category_spend_limit'],
        'total_spent': json['total_spent'] == null ? undefined : json['total_spent'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
    };
}

export function ICategorySpendLimitDtoToJSON(json: any): ICategorySpendLimitDto {
    return ICategorySpendLimitDtoToJSONTyped(json, false);
}

export function ICategorySpendLimitDtoToJSONTyped(value?: ICategorySpendLimitDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'policy_id': value['policy_id'],
        'category_type': value['category_type'],
        'category_spend_limit': value['category_spend_limit'],
        'total_spent': value['total_spent'],
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString().substring(0,10)),
        'valid_to': value['valid_to'] == null ? undefined : ((value['valid_to']).toISOString().substring(0,10)),
    };
}

